export default "__VITE_ASSET__Dv_7eDn4__"